<template>
    <div class="px-1 h-100">
        <div class="dataUploadTitle "> Ingreso por Animales </div>
        <div>
            <validation-observer ref="registerForm">
                <b-form class="auth-register-form " @submit.prevent="validationForm">
                    <b-form-group class="datePicker">
                        <h5 class="font-weight-bold ">
                            Fecha
                        </h5>
                        <flat-pickr v-model="dateDefault" class="form-control" />
                    </b-form-group>
                   <div>Seleccionar Animales:</div>
                 
                      <div>Filtrar por:</div>
                      
                     <b-form-group>
                        <div class="d-flex">
                            <b-form-checkbox id="male" v-model="status1" name="checkbox-1">
                                Macho
                            </b-form-checkbox>
                            <b-form-checkbox id="female" v-model="status2" name="checkbox-2" class="ml-1">
                                Hembra
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                     <b-form-group label="Edad" label-for="age">
                        <v-select id="age" v-model="age" :options="ageOptions" label="text" />
                      </b-form-group>
                    
                    <div class="d-flex flex-column justify-content-center pt-0 px-3">
                        <div class="d-flex justify-content-between">
                            <b-form-group label=" Animal" label-for="animal" class="mr-1 w-50">
                                <validation-provider #default="{ errors }" name="animal" rules="required">
                                    <b-form-input id="animal" v-model="reason" class="w-100"
                                        :state="errors.length > 0 ? false : null" name="animal" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group label=" Peso Venta" label-for="salesWeight" class="mr-1 w-50">
                                <validation-provider #default="{ errors }" name="salesWeight" rules="required">
                                    <b-form-input id="salesWeight" v-model="salesWeight" class="w-100"
                                        :state="errors.length > 0 ? false : null" name="reason" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group label="Total" label-for="total" class="w-50">
                                <validation-provider #default="{ errors }" name="total" rules="required">
                                    <b-form-input id="total" v-model="total" class="w-100"
                                        :state="errors.length > 0 ? false : null" name="total" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </div>
                        <div class="d-flex justify-content-around">
                            <b-form-group class="mr-1 w-50">
                                <validation-provider #default="{ errors }" name="reason" rules="required">
                                    <b-form-input id="reason" v-model="reason" class="w-100"
                                        :state="errors.length > 0 ? false : null" name="reason" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group class="mr-1 w-50">
                                <validation-provider #default="{ errors }" name="reason" rules="required">
                                    <b-form-input id="reason" v-model="reason" class="w-100"
                                        :state="errors.length > 0 ? false : null" name="reason" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group class="w-50">
                                <validation-provider #default="{ errors }" name="reason" rules="required">
                                    <b-form-input id="reason" v-model="reason" class="w-100"
                                        :state="errors.length > 0 ? false : null" name="reason" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </div>
                        <div class="d-flex justify-content-around">
                            <b-form-group class="mr-1 w-50">
                                <validation-provider #default="{ errors }" name="reason" rules="required">
                                    <b-form-input id="reason" v-model="reason" class="w-100"
                                        :state="errors.length > 0 ? false : null" name="reason" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group class="mr-1 w-50">
                                <validation-provider #default="{ errors }" name="reason" rules="required">
                                    <b-form-input id="reason" v-model="reason" class="w-100"
                                        :state="errors.length > 0 ? false : null" name="reason" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group class="w-50">
                                <validation-provider #default="{ errors }" name="reason" rules="required">
                                    <b-form-input id="reason" v-model="reason" class="w-100"
                                        :state="errors.length > 0 ? false : null" name="reason" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </div>
                        <div class="d-flex justify-content-around">
                            <b-form-group class="mr-1 w-50">
                                <validation-provider #default="{ errors }" name="reason" rules="required">
                                    <b-form-input id="reason" v-model="reason" class="w-100"
                                        :state="errors.length > 0 ? false : null" name="reason" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group class="mr-1 w-50">
                                <validation-provider #default="{ errors }" name="reason" rules="required">
                                    <b-form-input id="reason" v-model="reason" class="w-100"
                                        :state="errors.length > 0 ? false : null" name="reason" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group class="w-50">
                                <validation-provider #default="{ errors }" name="reason" rules="required">
                                    <b-form-input id="reason" v-model="reason" class="w-100"
                                        :state="errors.length > 0 ? false : null" name="reason" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </div>
                    </div>
                   
                        <b-form-group label=" # Guia de movilizacion" label-for="mobilization" class="mr-1">
                            <validation-provider #default="{ errors }" name="mobilization" rules="required">
                                <b-form-input id="mobilization" v-model="total" class="w-100"
                                    :state="errors.length > 0 ? false : null" name="mobilization" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group label=" # de Comprobante" label-for="voucher" class="mr-1">
                            <validation-provider #default="{ errors }" name="voucher" rules="required">
                                <b-form-input id="voucher" v-model="reason" class="w-100"
                                    :state="errors.length > 0 ? false : null" name="voucher" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    
                    <div class="d-flex align-items-center justify-content-center ">

                            <b-button type="submit"
                                class="bg-primary  w-75 ">
                                 Cargar Ingreso 
                            </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </div>
        <ControlMenu />
    </div>
</template>



<script>
import ControlMenu from '@/components/ControlMenu.vue'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {  BFormTextarea, BFormGroup, BFormInput, BForm, BImg, BButton, BFormCheckbox, BModal } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'
export default {
    components: {
        ControlMenu,
        flatPickr,
        BModal,
        BFormGroup,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        BFormInput,
        BForm,
        required,
        vSelect,
        BImg,
        BButton,
        BFormCheckbox,
        BFormTextarea,
    },
    data() {
        return {
            date: null,
            dateDefault: null,
            timePicker: null,
            dateNtim: null,
            multiDate: null,
            rangeDate: null,
            humanDate: null,
            disableDate: null,
            inlineDate: null,
            veterinarian: '',
            femaleAnimal: null,
            totalLitter: '',
            modalShow:false,
            reason: '',
            age: '',
            batch: '',
            animal: '',
            options: [
                { text: '1' },
                { text: '2' },
                { text: '3' },
            ],
            ageOptions: [
                { text: '1' },
                { text: '2' },
                { text: '3' },
            ],
            batchOptions: [
                { text: '1' },
                { text: '2' },
                { text: '3' },
            ],
            animalOptions: [
                { text: '1' },
                { text: '2' },
                { text: '3' },
            ],
        }
    },
}
</script>
    

<style lang="scss">
.dataUploadTitle {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 23px;
    color: #5E5873;
}



@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>